// extracted by mini-css-extract-plugin
module.exports = {"container":"Emails_container__1JIVU","limiter":"Emails_limiter__1JBN0"};